var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.16836 0 8.32222 0.0951112 8.39751 0.245685L15.9531 15.3568C16.022 15.4946 16.0146 15.6582 15.9336 15.7892C15.8526 15.9202 15.7096 16 15.5556 16H0.444445C0.29041 16 0.147361 15.9202 0.0663786 15.7892C-0.0146036 15.6582 -0.0219637 15.4946 0.0469207 15.3568L7.60249 0.245685C7.67778 0.0951112 7.83165 0 8 0ZM1.16357 15.1111H14.8364L8 1.43825L1.16357 15.1111Z",
    fill: "#FFE5BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11133 6.2219C7.11133 5.73096 7.50928 5.33301 8.00022 5.33301C8.49115 5.33301 8.88911 5.73096 8.88911 6.2219V10.6663C8.88911 11.1573 8.49115 11.5552 8.00022 11.5552C7.50928 11.5552 7.11133 11.1573 7.11133 10.6663V6.2219Z",
    fill: "#FFE5BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11133 13.3182C7.11133 12.8356 7.50262 12.4443 7.98524 12.4443H8.01519C8.49786 12.4443 8.88911 12.8356 8.88911 13.3182C8.88911 13.8009 8.49786 14.1922 8.01519 14.1922H7.98524C7.50262 14.1922 7.11133 13.8009 7.11133 13.3182Z",
    fill: "#FFE5BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f305cd1fcc75dfdbaa953bf04452101e.svg";
export { ForwardRef as ReactComponent };